import { AppEnvironments } from '@models/app-environments';

export const environment = {
  environment: AppEnvironments.development,
  apiUrl: 'https://development-zbportal-linux.azurewebsites.net',
  proxyApiUrl: 'https://dev-api-management-zbportal.azure-api.net',
  assetUrl: 'https://development-cdn.zaner-bloser.com/',
  skofUrl: 'https://development-cdn.zaner-bloser.com',
  routeGuardLoggingEnabled: true,
};
